<template>
    <div class="card">
        <div class="card-body">
            <h4 class="card-title">{{ cardTitle }}</h4>

            <p class="card-title-desc">
                {{ description }}
            </p>
            <div class="col-8 d-flex align-items-center">
                <b-form-input v-model="searchFilter" type="search" placeholder="Αναζητήστε Όνομα ή Κάρτας"
                    @keyup.enter="onSearchPerson"></b-form-input>
                <b-input-group-append class="d-flex">
                    <b-button variant="primary" @click.prevent="onSearchPerson">
                        <i class="bx bx-search-alt-2"></i>
                    </b-button>
                    <b-button v-if="searchFilter.length > 0" variant="danger" @click.prevent="clearSearch">
                        <i class="bx bx-x"></i>
                    </b-button>

                </b-input-group-append>
            </div>
            <div class="justify-content-between col-12">
                <b-table :items=entity :fields="tableFields">
                </b-table>
                <b-pagination v-model="currentPageModal" :total-rows="count" :per-page="perPage"
                    aria-controls="my-table" class="pagination pagination-rounded mb-0"></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import session from "../../../../api/session";
export default {
    props: {
        modalId: String,
        cardTitle: String,
        description: String,
        supervisorId: {
            required: false,
            type: Number,
        },
    },
    data() {
        return {
            entity: [],
            people: {},
            tableFields: [
                { key: 'person_full_name', label: 'Ονοματεπώνυμο' },
                { key: 'person_card_number', label: 'Αριθμός Κάρτας' },
            ],
            currentPageModal: 1,
            perPage: 10,
            count: 0,

            selectedPeople: {},
            searchFilter: ""
        }

    },
    watch: {
        currentPageModal() {
            this.fetchPeople()
        }
    },
    methods: {
        async fetchPeople() {
            let data = {
                page: this.currentPageModal,
                search: this.searchFilter
            }
            console.log(this.supervisorId);
            let urlparams = new URLSearchParams(data).toString();
            await session
                .get(`api/supervisor-group/${this.supervisorId}/?${urlparams}`)
                .then((resp) => {
                    console.log(resp.data.results)
                    console.log(resp.data.count)
                    this.entity = resp.data.results.map(person => ({
                        id: person.id,
                        person_full_name: person.person_full_name,
                        person_card_number: person.person_card_number
                    }));
                    this.count = resp.data.count;
                }).catch((e) => {
                    console.log(e.response.data);
                })
        },
        onSearchPerson() {
            this.currentPageModal = 1;
            this.fetchPeople();
        },
        clearSearch() {
            this.searchFilter = "";
            this.currentPageModal = 1;
            this.fetchPeople();
        }
    },
    created() {
        this.fetchPeople()
    }



}
</script>